/**
 * EditUrlSection Component
 * UI for editing URL in an existing URL document (edit mode)
 * Pure presentational component
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, TextField } from '@mui/material';
import { EditUrlSectionProps } from '../types';

export const EditUrlSection: React.FC<EditUrlSectionProps> = ({
  url,
  onChange
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Typography variant="subtitle1" sx={{ mt: 3, mb: 2, fontWeight: 600 }}>
        {t('documents.dialog.documentUrl')}
      </Typography>
      <TextField
        margin="normal"
        required
        fullWidth
        label={t('documents.dialog.url')}
        name="url"
        value={url}
        onChange={onChange}
        helperText={t('documents.dialog.urlHelp')}
        variant="outlined"
      />
    </>
  );
};
